import React, { useState } from 'react'
import ReactDOM from 'react-dom'

const OFFSET = 14

const TruncatedText = ({ text = '', max = 25, className, cursor }) => {
  const [pos, setPos] = useState(null)

  if (text.length <= max) return <span className={className}>{text}</span>

  const move = (e) => setPos({ x: e.clientX, y: e.clientY })

  return (
    <>
      <span
        className={className}
        style={cursor ? { cursor } : undefined}
        onMouseEnter={move}
        onMouseMove={move}
        onMouseLeave={() => setPos(null)}>
        {`${text.slice(0, max)}…`}
      </span>
      {pos &&
        ReactDOM.createPortal(
          <div
            role='tooltip'
            className='s7'
            style={{
              position: 'fixed',
              left: pos.x + OFFSET,
              top: pos.y + OFFSET,
              maxWidth: 320,
              padding: '4px 8px',
              background: '#fff',
              color: '#000',
              border: '1px solid rgba(0, 0, 0, 0.2)',
              borderRadius: 4,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              pointerEvents: 'none',
              zIndex: 2000,
            }}>
            {text}
          </div>,
          document.body,
        )}
    </>
  )
}

export default TruncatedText
